import Cookies from "js-cookie";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { AdminContext } from "../context/AdminContext";
import StorageServices from "../services/StorageServices";
import BusinessServices from "../services/BusinessServices";

export default function useSelectStore() {
  const history = useHistory();

  const { dispatch } = useContext(AdminContext);

  const handleStoreSelect = async (businessCode, user) => {
    // Reset active user info
    dispatch({ type: "USER_LOGIN", payload: user?.info });
    Cookies.set("TD-User-Token", "Bearer " + user?.token);
    StorageServices.set("adminInfo", JSON.stringify(user?.info));

    // fetch new store
    const response = await BusinessServices.start();

    //select new store
    const activeBusiness = response?.data?.find(
      (business) => business.business_code === businessCode
    );

    if (activeBusiness) {
      // Set store info
      StorageServices.set("TD-Active-Team-id", activeBusiness.business_code);
      StorageServices.set("TD-Active-Team-Attr", JSON.stringify(activeBusiness.business_attributes || {}));
      StorageServices.set(
        "TD-Active-Team-Stats",
        JSON.stringify(activeBusiness.stats || [])
      );
      StorageServices.set("TD-Active-Team", JSON.stringify(activeBusiness));
      StorageServices.set("TD-Teams", JSON.stringify(response.data));
      Cookies.remove("TD-Business-Token");
      Cookies.set("TD-Business-Token", "Bearer " + user?.token);
      dispatch({ type: "ACTIVE_STORE", payload: activeBusiness });

      history.replace("/ai-suggestions");
    } else {
      history.replace("/login");
    }
  };
  return { handleStoreSelect };
}
